import useCar from "../../node_modules/common/src/components/report/useCar";
import parking from "../../node_modules/common/src/components/report/parking";
import stay from "../../node_modules/common/src/components/report/stay";
import driving from "../../node_modules/common/src/components/report/driving";
import daily from "../../node_modules/common/src/components/report/daily";
import refuel from "../../node_modules/common/src/components/report/refuel";
import defuel from "../../node_modules/common/src/components/report/defuel";
var data = [
  {
    path: "/driving",
    component: driving
  },
  {
    path: "/daily",
    component: daily
  },
  {
    path: "/stay",
    component: stay
  }, {
    path: "/parking",
    component: parking
  },
  {
    path: "/refuel",
    component: refuel
  },
  {
    path: "/defuel",
    component: defuel
  },
  {
    path: "/useCar",
    component: useCar
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/report.js